import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import { useState, createContext } from 'react';
import Helmet from './components/layout/helmet';
import Navbar from './components/layout/nav-bar';
import Footer from './components/layout/footer';
import MobileNav from './components/layout/mobile-nav';
import ScrollToTopButton from './components/layout/back-to-top';
import SignUp from './components/signup/main';
import Main from './components/demo/main';
import Home from './components/landing-page/home';
import About from './components/about-us/about';
import "./style.scss";

export const MenuContext = createContext<any>(null);


function App() {

  const [isOpen, setIsOpen] = useState(false);

  const [isOn, setIsOn] = useState(false);

  return (
    <MenuContext.Provider value={{isOpen, setIsOpen, isOn, setIsOn}}>
      <Router>
        <Helmet>
        <ScrollToTopButton />
        <Navbar />
        <MobileNav />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book-a-demo" element={<Main />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/about-us" element={<About />} />
            {/* <Route path="/blogs" element={<Blog />} /> */}
        </Routes>
        <Footer />
        </Helmet>
      </Router>
    </MenuContext.Provider>
  );
}

export default App;

